import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { StandaloneSelectField } from 'components/FormElements/FormSelectField';
import React, { useEffect, useRef, useState } from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import { BarLoader } from 'react-spinners';
import { APINetworkCall, callAPI } from '../../../../../utils/network/index';
import DeleteButton from '../../MenuEditor/components/shared/DeleteButton';
import { PrepAreaTooltip } from '../../MenuEditor/components/shared/TooltipModals';
import './index.scss';

export const EditPrinterDialog = ({
  onUpdated,
  fullScreen,
  open,
  onClose,
  showAlert,
  printer,
}) => {
  const { _id, friendly_name, prep_area } = printer;

  const [printerName, setPrinterName] = useState(friendly_name);
  const [prepArea, setPrepArea] = useState(prep_area);
  const [updatingPrinter, setUpdatingPrinter] = useState(false);

  const nameElement = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (nameElement.current) {
        nameElement.current.focus();
      }
    }, 100);
  }, []);

  const editPrinter = async (removePrinter = false) => {
    if (prepArea === '') {
      showAlert(
        'Invalid Prep Area',
        'You must select a Prep Area. Please use the dropdown.'
      );
      return;
    }

    setUpdatingPrinter(true);

    const body = {
      printer_id: _id,
      delete: removePrinter,
      changes: { prep_area: prepArea, friendly_name: printerName },
    };
    const apiRequest = APINetworkCall.fromURL(
      `${process.env.REACT_APP_API_URL}/print/update-printer`,
      body,
      'POST'
    );

    try {
      await callAPI(apiRequest);
    } catch (e) {
      console.error(e);
      showAlert(
        'Failure',
        'Sorry, we could not update the Print Device. Please try again later.'
      );
    }

    setUpdatingPrinter(false);
    onUpdated();
  };

  const printerUrl = `${process.env.REACT_APP_API_URL}/print/connect/${_id}`;

  return (
    <Dialog
      className="dialog__add__printer"
      disableBackdropClick={false}
      disableEscapeKeyDown={false}
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="add-printer"
    >
      <div style={{ position: 'absolute', top: 24, right: 24 }}>
        <DeleteButton
          disabled={updatingPrinter}
          onClick={() => {
            editPrinter(true);
          }}
        />
      </div>
      <DialogTitle
        className="dialog__add__printer__title"
        id="responsive-dialog-title"
      >
        Edit Printer
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="centered__dialog__content__text">
          Fatsoma Tabb supports these Star printer series:
          <br />
          mC-Print2, mC-Print3, TSP654III and SP742.
        </DialogContentText>

        <div className="printer__details">
          <React.Fragment>
            <TextField
              fullWidth={true}
              label="Printer Name"
              inputRef={nameElement}
              autoFocus={true}
              onChange={evt => setPrinterName(evt.target.value)}
              value={printerName}
              className="settings__section__details__form__name printer__name"
              type="text"
              hinttext="Printer Name"
              placeholder="e.g. Front of House"
              margin="normal"
            />

            <StandaloneSelectField
              label={
                <span>
                  Prep Area <PrepAreaTooltip />
                </span>
              }
              autoFocus={true}
              displayEmpty
              value={prepArea}
              onChange={evt => setPrepArea(evt.target.value)}
            >
              <MenuItem value="" disabled>
                Select Prep Area
              </MenuItem>
              <MenuItem value="general">Front of House</MenuItem>
              <MenuItem value="kitchen">Kitchen</MenuItem>
            </StandaloneSelectField>
          </React.Fragment>

          <div style={{ marginTop: 8 }} />

          <React.Fragment>
            <div
              className="settings__section__preview__url"
              style={{ marginBottom: 10 }}
            >
              {printerUrl}
            </div>
            <p class="printer__connection__help">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://intercom.help/tabb/en/articles/5188075-how-to-set-up-connect-your-printer"
              >
                Printer Connection Help
              </a>
            </p>
          </React.Fragment>
        </div>

        <div className="dialog__button__row">
          <Button
            disabled={updatingPrinter}
            className="fatsoma__cta__secondary"
            onClick={() => onClose()}
            color="primary"
          >
            Close
          </Button>

          <Button
            disabled={updatingPrinter}
            className="fatsoma__cta"
            onClick={() => {
              editPrinter(false);
            }}
          >
            {!updatingPrinter && 'Update'}
            {updatingPrinter && <BarLoader color="#fff" height={4} />}
          </Button>
        </div>
      </DialogContent>

      <Loader text="Updating" loading={updatingPrinter} />
    </Dialog>
  );
};

export default withMobileDialog()(EditPrinterDialog);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Settings/EditPrinterDialog/index.jsx